import bonnet from '~/assets/icons/bonnet.svg';
import chassisTrim from '~/assets/icons/chassis_trim.svg';
import disks from '~/assets/icons/disks.svg';
import doorHandles from '~/assets/icons/door_handles.svg';
import engine from '~/assets/icons/engine_2.svg';
import exhaust from '~/assets/icons/exhaust.svg';
import frontBumper from '~/assets/icons/front_bumper.svg';
import frontFender from '~/assets/icons/front_fender.svg';
import frontLight from '~/assets/icons/front_light.svg';
import interior from '~/assets/icons/interior.svg';
import kit from '~/assets/icons/kit.svg';
import rearBumper from '~/assets/icons/rear_bumper.svg';
import roof from '~/assets/icons/roof.svg';
import sideSkirts from '~/assets/icons/side_skirts.svg';
import trunk from '~/assets/icons/trunk.svg';
import wheelSettings from '~/assets/icons/wheel_settings.svg';
import { VehicleTuningCategory } from '~/shared';

const MAIN_FIXED_CATEGORY_COUNT = 3;

export const getResetTuningIndex = (nonExteriorCategoryCount: number): number =>
	nonExteriorCategoryCount + MAIN_FIXED_CATEGORY_COUNT;

export const CATEGORY_ICONS: Record<VehicleTuningCategory, string> = {
	[VehicleTuningCategory.FRONT_BUMPER]: frontBumper,
	[VehicleTuningCategory.REAR_BUMPER]: rearBumper,
	[VehicleTuningCategory.DOORS]: doorHandles,
	[VehicleTuningCategory.BONNET]: bonnet,
	[VehicleTuningCategory.BOOT]: trunk,
	[VehicleTuningCategory.SKIRTS]: sideSkirts,
	[VehicleTuningCategory.ROOF]: roof,
	[VehicleTuningCategory.FENDERS]: frontFender,
	[VehicleTuningCategory.LIGHTS]: frontLight,
	[VehicleTuningCategory.EXHAUST]: exhaust,
	[VehicleTuningCategory.INTERIOR]: interior,
	[VehicleTuningCategory.CHASSIS]: chassisTrim,
	[VehicleTuningCategory.ENGINE]: engine,
	[VehicleTuningCategory.RIMS]: disks,
	[VehicleTuningCategory.KITS]: kit,
	[VehicleTuningCategory.WHEEL_SETTINGS]: wheelSettings,
};
